import { SiteInterface } from '../site-line-selection/site-line-selection.model';
import { IMenuPermissions } from '../../../constants';
import { IRole } from '../../shared/service/roles/roles.model';
import { IGenericObject } from '../../shared/model/interface/generic.model';

export interface GetNavigationMenuResponseInterface {
  data: GetNavigationMenuResponseDataInterface;
  success: boolean;
}

export interface GetNavigationMenuResponseDataInterface {
  clientLogo: string;
  menu: MenuItemInterface[];
  menuList: string[];
  singleSiteAndLine: boolean;
}

export interface MenuItemInterface {
  main?: GetNavigationMenuResponseMainInterface[];
  label?: string;
  parent?: null;
  key: string;
  link: string;
  name: string;
  icon: string;
  isUpgradeBadgeEnabled: boolean;
}

export interface GetNavigationMenuResponseMainInterface extends MenuInterface {
  children?: GetNavigationMenuResponseMainInterface[];
  state?: string;
  name: string;
  type?: string;
  icon: string;
  external: boolean;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  badge?: BadgeItem[];
  key: string;
}

export interface BadgeItem {
  type: string;
  value: string;
}

export interface MenuSearchableKeyInterface {
  name?: string;
  state?: string;
}

export interface SwitchHomePageResponseInterface {
  success: boolean;
}
export interface MainStateInterface {
  getActiveSitesLoading: boolean;
  getActiveSitesLoaded: boolean;
  activeSites: SiteInterface[];
  getNavigationMenuLoading: boolean;
  sendContactSupportLoading: boolean;
  getNavigationMenuLoaded: boolean;
  authorizedPages: string[];
  menu: GetNavigationInformationResponseInterface;
  menuItemHash?: IGenericObject<MenuInterface>;
  clientLogo: string;
  singleSiteAndLine: boolean;
  getCustomMailGroupsLoading: boolean;
  getCustomMailGroupsLoaded: boolean;
  customMailGroups: ICustomAndDefaultMailGroupLists;
  allowedDomainsLoading: boolean;
  allowedDomainsLoaded: boolean;
  allowedDomains: IAllowedDomain[];
  rolesLoading: boolean;
  rolesLoaded: boolean;
  roles: Partial<IRole>[];
  activeSiteModules: Partial<IMenuPermissions['modules']>;
}

export interface MenuInterface {
  id: number;
  name: string;
  staticName: string;
  levelId: number;
  authorizedSites: string;
  authorizedLines: string;
  children?: MenuInterface[];
  parentId: number;
  link: string;
  orders: number;
  status: boolean;
  icon: string;
  external: boolean;
  inProgress: boolean;
  isUpgradeBadgeEnabled: boolean;
  isNew: boolean;
  appId: number;
  key: string;
  isHidden?: boolean;
  isSystem?: boolean;
}

export interface GetNavigationInformationResponseInterface {
  menus: MenuInterface[];
  clientLogo: string;
  singleSiteAndLine: boolean;
}

export interface MenuTreeInterface extends MenuInterface {
  children?: MenuInterface[];
  key: string;
  state?: string;
  type?: string;
  label?: string;
  parent?: null;
  main?: GetNavigationMenuResponseMainInterface[];
}

export interface IMailRecipients {
  mailGroupId: number;
  recipientMailAddress: string;
  recipientName: string;
  recipientPhoneNumber: string | null;
}

export interface InterfaceCustomMailGroupInterface {
  id: number;
  siteId: number | null;
  title: string | null;
  socialLink: string | null;
  isCustomContactGroup: boolean;
}

export interface ICustomMailGroupLists extends InterfaceCustomMailGroupInterface {
  notificationMailRecipient?: IMailRecipients[];
}

export interface ICustomAndDefaultMailGroupLists {
  customMailGroups: ICustomMailGroupLists[];
  defaultMailGroups: IGetContactGroupsForUsersResponseDto;
}

export interface IAllowedDomain {
  id: number;
  domain: string;
  isIdpEnforcedEmail: boolean;
}

export interface IGetContactGroupsForUsersResponseDto {
  contactSupervisorExist: boolean;

  contactWarehouseExist: boolean;

  contactScwExist: boolean;

  contactQualityExist: boolean;

  contactMaintenanceExist: boolean;

  contactItExist: boolean;
}

export interface IGetContactDefaultMailGroups {
  type: string;
  title: string;
}

export const defaultContactGroupMapping: Array<{
  flag: keyof IGetContactGroupsForUsersResponseDto;
  translationKey: string;
}> = [
  { flag: 'contactSupervisorExist', translationKey: 'general.contactSupervisor' },
  { flag: 'contactWarehouseExist', translationKey: 'general.contactWarehouse' },
  { flag: 'contactScwExist', translationKey: 'general.contactSCW' },
  { flag: 'contactQualityExist', translationKey: 'general.contactQuality' },
  { flag: 'contactMaintenanceExist', translationKey: 'general.contactMaintenance' },
  { flag: 'contactItExist', translationKey: 'general.contactIt' },
];
